import React, { useState } from 'react'
import {FiChevronDown,FiChevronUp,FiChevronRight} from 'react-icons/fi'

// overview section 
import clients_served from '../folder/images/overview/clients_served.png'
import inhouse_employees from '../folder/images/overview/inhose_employees.png'
import years_in_industry from '../folder/images/overview/years_in_industry.png'
import total_projects from '../folder/images/overview/total_projects.png'

// team 
// import achuth from '../folder/images/teams/achuth_gowda.png'
import achuth from '../folder/images/teams/ag2.png'
import coo from '../folder/images/teams/coo2.png'
// import pp from '../folder/images/teams/pp.png'
import john from '../folder/images/teams/john-vinod2.png'
import pramod from '../folder/images/teams/pramod1.png'
// import maltesh from '../folder/images/teams/maltesh.png'
import maltesh from '../folder/images/teams/maltesh1.png'
import shubha from '../folder/images/teams/shubha.png'
import suhasini from '../folder/images/teams/suhasini2.png'
import anireeth from '../folder/images/teams/anireeth1.png'
// import laxmi from '../folder/images/teams/mohana_laxmi.png'
import lingaraju from '../folder/images/teams/lingaraju.png'
// import anil from '../folder/images/teams/anil_kumar.png'

import CountUp from 'react-countup';

// import anireeth from '../../folder/images/teams/anireeth.png'
// import pramod from '../../folder/images/teams/pramod.png'
// import sandeep from '../../folder/images/teams/sandeep.png'
// import shubha from '../../folder/images/teams/shubha.png'
// import suhasini from '../../folder/images/teams/suhasini.png'

// import {FaLinkedinIn,FaWhatsapp} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { CiLinkedin } from "react-icons/ci";

function About() {



    const [step,setstep] = useState(false)

    const navigator = useNavigate()

    const data = [
        {
         img:clients_served,
         heading:'Clients Served',
         count:6000
        },
        {
         img:inhouse_employees,
         heading:'In-House Employee',
         count:700
        },
        {
         img:years_in_industry,
         heading:'Years In Industry',
         count:11
        },
        {
         img:total_projects,
         heading:'Overall Projects',
         count:500
        }
   
    ]

    const teams = [
        {
         img:achuth,
         name:'Achuth Gowda',
         designation:'Founder and Managing Director',
         linked_in:'https://www.linkedin.com/in/achuth-gowda-mrics-88b9a26/',
         whats_app:''
        },
        {
          img:john,
          name:'John Vinod Kumar',
          designation:'Senior Director',
          linked_in:'https://www.linkedin.com/in/john-vinod-kumar-39761519/',
          whats_app:'https://api.whatsapp.com/send?phone=919845010178&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
         },
         {
          img:anireeth,
          name:'Anireeth',
          designation:'Director and Head-Corporate Affairs and Public Institutions',
          linked_in:'https://www.linkedin.com/in/anireeth-cr-6618918a/',
          whats_app:'https://api.whatsapp.com/send?phone=919739717308&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
         },
        // {
        //   img:coo,
        //   name:'Avina Llyold',
        //   designation:'Chief Operating Officer',
        //   linked_in:'https://www.linkedin.com/in/avina-lloyd-/',
        //   whats_app:''
        //  },

        {
          img:pramod,
          name:'Pramod GP',
          designation:'Director – Real Estate Trasnactions',
          linked_in:'https://www.linkedin.com/in/pramod-gp-3805a592/',
          whats_app:'https://api.whatsapp.com/send?phone=+919845290971&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
         },
        {
         img:maltesh,
         name:'Maltesh Sigase',
         designation:'Director – Projects ',
         linked_in:'https://www.linkedin.com/in/malthesh-sigase-121601168/',
         whats_app:'https://api.whatsapp.com/send?phone=+919845290971&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
        },
        {
          img:shubha,
          name:'ShubaLaxmi P Alva',
          designation:'Director – Facility Management Services ',
          // https://www.linkedin.com/in/malthesh-sigase-121601168/
          linked_in:'',
          whats_app:'https://api.whatsapp.com/send?phone=+919845290971&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
        },

         {
          img:suhasini,
          name:'Suhasini Deshpande',
          designation:'Director – HR Labs ',
          linked_in:'https://www.linkedin.com/in/suhasini-deshpande-a6639711',
          whats_app:'https://api.whatsapp.com/send?phone=+919845290971&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
         },
        
        //  {
        //   img:pp,
        //   name:'Prakruthi Prasanna',
        //   designation:'Chief Architect of Green Initiatives - Shilpa Foundation',
        //   linked_in:'https://www.linkedin.com/in/achuth-gowda-mrics-88b9a26/',
        //   whats_app:''
        //  },
      
      
        
        // {
        //   img:anireeth,
        //   name:'Anireeth',
        //   designation:'Head-Corporate Affairs and Public Institutions',
        //   linked_in:'https://www.linkedin.com/in/anireeth-cr-6618918a',
        //   whats_app:'https://api.whatsapp.com/send?phone=919739717308&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
        //  },
        // {
        //  img:laxmi,
        //  name:'Mohana Laxmi',
        //  designation:'Backend Head',
        //  linked_in:'https://www.linkedin.com/in/anireeth-cr-6618918a',
        //  whats_app:'https://api.whatsapp.com/send?phone=919739717308&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
        // },
        {
          img:lingaraju,
          name:'Lingaraju',
          designation:'IT Head and FTS Director',
          linked_in:'https://www.linkedin.com/in/abhi-raj-0872a0112/',
          whats_app:'https://api.whatsapp.com/send?phone=919739717308&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
         },
        //  {
        //   img:anil,
        //   name:'Anil Kumar',
        //   designation:'Finance Head',
        //   linked_in:'https://www.linkedin.com/in/anireeth-cr-6618918a',
        //   whats_app:'https://api.whatsapp.com/send?phone=919739717308&text=Hi%20I%20would%20like%20to%20connect%20with%20you&source=&data='
        //  },
       
   
    ]

  return (
    <div className='w-screen h-full bg-white overflow-hidden'>
        <div className='relative h-[40vh] md:min-h-[60vh] md:max-h-[60vh] relative bg-about_us-bg bg-center bg-no-repeat bg-cover'>
          
          <div className='absolute  top-[6%] left-[10%]'>
          <h6 className='font_normal group text-white text-[13px] flex items-center'><span onClick={()=>navigator('/')} className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Home</span> <FiChevronRight className='mx-2' />  <span className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>About Us</span>  </h6>  
          </div>
          <h1 className='text-white flex font_normal text-[13px] p-6 bg-black px-10 md:text-[16px] absolute bottom-0 left-[10%] bg-opacity-70'><span className='min-w-[4px] block min-h-[18px] max-h-[35px] rounded mt-[-1px] mr-4 bg-[#fff]'></span> We are data driven company who always support our clients</h1>
        </div>

        
       
       <div>
         <div className='w-[90vw] md:w-[80vw] mx-auto py-20'>
          <h6 data-aos="fade-left" className='font_bold text-[19px] flex'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> About Us</h6>
          {/* <h6  data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Fidelitus Corp is a leading provider of comprehensive, end-to-end property services,
          specializing in both commercial and residential sectors. We offer a full spectrum of solutions,
          from selecting optimal spaces to designing efficient layouts, managing facilities within
          budget, enhancing aesthetics through art, and sourcing the right talent. Our goal is to ensure
          that clients achieve success by making the most informed decisions for their business needs.</h6> */}


          {/* <h6 data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Fidelitus is a leading provider of comprehensive business solutions, specializing in Real Estate, Facilities Management Services (FMS), HR Labs, Interior Project Design, and Technology Solutions. We help businesses by selecting optimal spaces, designing efficient layouts, managing facilities, and enhancing aesthetics through curated art. Our FMS services ensure seamless operations, covering maintenance, security, housekeeping, and sustainability initiatives. HR Labs connects businesses with top talent, offering recruitment, workforce training, and employee engagement strategies.</h6> */}
          <h6 data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Fidelitus Corp, being a dominant player in the Commercial Real Estate landscape, have evolved to extend our professional services in  Turnkey project management, Integrated Facilities Management Services and Human Resources Solutions. Our relentless commitment to innovation, customer-centric, and sustainable practices has made us a trusted partner for countless businesses. At Fidelitus Corp, we are more than just a collection of businesses; we are a power house of diverse ventures united under a single brand that believes in the power of collaboration, harnessing innovation, adapting to changes and driving positive social impact.</h6>
         


          {step &&
          <>
          <h6 data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Guided by a team of seasoned experts, we’ve earned a reputation for integrity, reliability, and innovation in commercial real estate and beyond. We prioritise client’s needs, offering tailored solutions. embracing challenges, we continuously strive for growth and improvement, as is our values that forms the foundation of our work culture, encompassing Customer-centric Accountability, Resilience & Respect, Excellence, and Sustainability, Promising you that Fidelitus CARES.</h6>
          <h6 data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Beyond our core services, we take pride in Fidelitus Gallery, a platform that celebrates artistic brilliance and fosters creativity. The Shilpa Foundation is another initiative close to our hearts, working to provide underprivileged children with : - Education, Health & Environment, for a brighter future. Join us on this transformative journey as we shape a world where diverse businesses coexist harmoniously under one unified brand.</h6>
          </>
          // <h6 data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Our Interior Project Design services transform commercial and residential spaces into efficient, aesthetically pleasing environments, while Fidelitus Technologies drives digital transformation through IT solutions, software development, and smart infrastructure services. Backed by a skilled, cross-functional team, we integrate market intelligence with strategic guidance to empower business growth. Our client-centric approach ensures cost-effective, high-quality solutions tailored to evolving business needs. With a proven track record, we enable organizations to focus on their core operations while we handle the complexities, ensuring long-term, sustainable success.</h6>
          // <h6 data-aos="fade-up" className='font_normal text-[14px] ml-5 mt-4'>Through our integrated platform, we deliver valuable market insights and strategic guidance,
          // empowering our clients to make decisions that drive sustainable growth. Backed by a proven
          // track record, we have built a highly skilled, cross-functional team of experts across various
          // specialties. We are committed to delivering seamless, holistic services, allowing our clients to
          // focus on their core operations while we handle the complexities of property management.</h6>
          
          }
        
          <h6 onClick={()=>setstep(!step)} className='group font_normal hover:underline cursor-pointer flex items-center justify-center text-[14px] text-center mt-6'>Read {step ? 'Less' : 'More'} {step ? <FiChevronUp size={24} className='transition-all duration-300 group-hover:scale-125  bg-white rounded-full p-1 shadow ml-4' /> : <FiChevronDown size={24} className='transition-all duration-300 group-hover:scale-125  bg-white rounded-full p-1 shadow ml-4' />} </h6> 
           

          <h6  data-aos="fade-up" className='font_bold text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Our Overview</h6>
          
          <div className='md:w-[90%] md:h-[150px] mx-auto grid grid-cols-2  md:grid-cols-4 md:gap-5 mt-10'>
            {data?.map((d,i)=>(
              <div  data-aos="fade-up" key={i} className='cursor-pointer group transition-all duration-300 flex flex-col p-5 items-center justify-center hover:bg-white hover:shadow-lg'>
                  <img alt={'img'} src={d?.img} className='w-[60px] object-contain opacity-70 transition-all duration-300  group-hover:scale-75' />
                  <h6 className='text-[15px] text-center font_normal mt-2'>{d?.heading}</h6>
                  <h6 className='text-[18px] text-center font_normal font-[900] mt-0'><CountUp end={d?.count}/> +</h6>
              </div>  
            ))}
          </div>

         <h6 data-aos="fade-right" className='font_bold text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Our Vision</h6>
         <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>To be the trusted global leader in providing integrated service solutions, setting the standard
for excellence in human resources, real estate transactions, interior design, and facility
management. We strive to create a future where seamless collaboration and sustainable
practices enable individuals and organizations to excel in ever-evolving environments,
driving innovation and fostering comprehensive growth.</h6>
         <h6 data-aos="fade-right" className='font_bold text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span> Our Mission</h6>
         <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>Our mission is to provide outstanding service through integrated solutions across human
resources, real estate transactions, interior design, and facility management. We are dedicated
to surpassing client expectations by delivering innovative, sustainable, and efficient solutions
that drive productivity and enhance well-being. With a strong commitment to integrity and
professionalism, we aim to create enduring value for our clients, employees, and
communities.</h6>
         {/* <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>Driven by innovation, collaboration, and a deep sense of social responsibility, we strive to be a catalyst for positive change in the real estate industry. By uniting diverse ventures under one brand, we leverage collective knowledge, resources, and expertise to create meaningful impacts that transcend boundaries and inspire sustainable growth.</h6>
         <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>Through constant adaptation and a customer-centric approach, we are committed to providing cutting-edge services that exceed expectations and foster long-lasting partnerships. Guided by a passion for transformative progress, we envision a world where our integrated platform empowers businesses to flourish and communities to thrive.</h6>
         <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>Together, with our global network of professionals, we forge ahead on a journey of continuous improvement, leaving an indelible mark of excellence and inspiration in every corner of the world we serve.</h6>
 */}


       

          </div>  
       </div>

       <div className='bg-gray-50 py-10'>
      <div className='w-[90%] md:w-[80%] mx-[5%] md:mx-[10%]'>
         <h6 data-aos="fade-right" className='font_bold text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Leaders of Fidelitus - Our Team</h6>
         <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>At Fidelitus, we take pride in nurturing and developing our employees' expertise, empowering them to excel in their roles. Our team is our greatest strength — together, we have consistently turned challenges into opportunities and made the impossible possible</h6>
         {/* <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>We are the leaders of fidelitus who make our employee expertise in their work and train them to expertise in their works! and team is our strength with them we have made impossible things as possible .</h6> */}
         

         <div className='grid mx-auto grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2'>
            {teams?.map((t,i)=>(
                <div data-aos="fade-up" key={i} className='group cursor-pointer mt-2 bg-white transition-all duration-300 relative pt-1 pb-1 px-1 shadow'>
                <img alt={'img'} src={t?.img} className='w-[100%] h-[190px]  md:h-[190px] lg:h-[220px] object-cover  duration-300  group-hover:scale-95 bg-[#f4f4f4]' />
                <h6 className='font_normal mt-2 text-[14px]'>{t?.name}</h6>
                <h6 className='font_normal text-[11px]'>{t?.designation}</h6>
                {t?.linked_in !== '' && <CiLinkedin onClick={()=>window.open(t?.linked_in)} size={24} className='cursor-pointer absolute right-5 top-5' />}
                </div>    
            ))}
         </div>
      </div>   
         </div>
    </div>
  )
}

export default About